import { cva } from 'noddi-ui-common';

export type LayoutContainerWidth = 'md' | 'lg' | 'xl' | 'xxl' | 'wide' | 'full';

/**
 * Outer horizontal gutter — same per width variant for nav and content so the
 * pill outer edge aligns with the content box outer edge at every breakpoint.
 */
export const layoutGutterVariants = cva('', {
  variants: {
    width: {
      md: 'px-5 sm:px-10',
      lg: 'px-5 sm:px-10',
      xl: 'px-5 sm:px-10',
      xxl: 'px-5 sm:px-10 xl:px-4',
      wide: 'px-5 sm:px-4',
      full: ''
    } satisfies Record<LayoutContainerWidth, string>
  },
  defaultVariants: { width: 'md' }
});

/**
 * Nav pill max-width — applied to the inner pill element, paired with an outer
 * layoutGutterVariants wrapper.
 */
export const navMaxWidthVariants = cva('mx-auto', {
  variants: {
    width: {
      md: 'max-w-screen-mdx',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      xxl: 'max-w-screen-2xl',
      wide: 'max-w-screen-2xl',
      full: 'max-w-none'
    } satisfies Record<LayoutContainerWidth, string>
  },
  defaultVariants: { width: 'lg' }
});

/**
 * Content max-width — narrow reading width (mdx) until the xl viewport,
 * then expands per variant. The `wide` variant lets content fill the
 * viewport from sm onwards and caps at 2xl at xl.
 */
export const contentMaxWidthVariants = cva('mx-auto', {
  variants: {
    width: {
      md: 'max-w-screen-mdx',
      lg: 'max-w-screen-mdx xl:max-w-screen-lg',
      xl: 'max-w-screen-mdx xl:max-w-screen-xl',
      xxl: 'max-w-screen-mdx xl:max-w-screen-2xl',
      wide: 'max-w-screen-mdx sm:max-w-none xl:max-w-screen-2xl',
      full: 'max-w-none'
    } satisfies Record<LayoutContainerWidth, string>
  },
  defaultVariants: { width: 'md' }
});
